/* this file is transformed by vux-loader */
/* eslint-disable */
export var UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS';
export var UPDATE_INVALID_RESPONSE = 'UPDATE_INVALID_RESPONSE';
export var SAVE_USER_INFO = 'SAVE_USER_INFO';
export var SAVE_USER_CONTACT = 'SAVE_USER_CONTACT';